import { createFileRoute } from '@tanstack/react-router'
import { InvitationsManagement } from '../../components/AdminInvitations'

export const Route = createFileRoute('/admin/invitations')({
  component: () => (
    <InvitationsManagement />
  ),
})
